const mutations = {
	SIDEBAR_COLLAPSE(state, status = null) {
		if (status) {
			state.sidebarCollapsed = status;
		} else {
			state.sidebarCollapsed = !state.sidebarCollapsed;
		}
	}
};

export default mutations;
